@if (pendingUsersLoading() || pendingUsers().length > 0) {
  <div class="pending-access-container">
  @if (pendingUsersLoading()) {
    <div class="fetch-pending-access" aria-live="polite">
    <mat-spinner diameter="18" aria-hidden="true"/>
    <span>Fetching pending requests…</span></div>
  } @else {
    <button class="pending-access-button" matButton="tonal" type="button"
            [disabled]="pendingUsersLoading()"
            (click)="openPendingUsersDialog()">
      <mat-icon aria-hidden="true">info</mat-icon>
      Pending access requests ({{ pendingUsers().length }})
    </button>
  }
  </div>
}

<fieldset>
  <legend>Users and groups</legend>
  <users-groups-controller [parentForm]="securityForm" (ownersChanged)="onOwnersChanged()"/>
</fieldset>

<fieldset>
  <legend>Marketplace settings</legend>
    <marketplace-controller [parentForm]="securityForm" itemType="Workflow"/>
</fieldset>
